'use client';

import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Whether the user asked the OS to limit animation.
 *
 * Read by the preview carousels: content that moves on its own, with no control to stop it, is
 * the exact case the setting exists for. They hold on the first preview instead, and the count
 * badge still says how many there are.
 *
 * Starts `false` rather than reading `matchMedia` during render — the server has no media queries,
 * and a mismatched first paint would hydrate as an error.
 */
const usePrefersReducedMotion = (): boolean => {
  const [prefersReduced, setPrefersReduced] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(QUERY);
    setPrefersReduced(mediaQuery.matches);

    const onChange = () => setPrefersReduced(mediaQuery.matches);
    mediaQuery.addEventListener('change', onChange);
    return () => mediaQuery.removeEventListener('change', onChange);
  }, []);

  return prefersReduced;
};

export default usePrefersReducedMotion;
